import React, { useEffect, useRef, useState } from "react";
import { AdyenCheckout, Card } from "@adyen/adyen-web";

import { Wrapper } from "nystem-components";
import app from "nystem";
import "./theme.css";

const uudecode = (code) => JSON.parse(window.atob(code));
const uuencode = (obj) => window.btoa(JSON.stringify(obj));

const errorRespons = {
  Refused: "Kort inte godkänt",
  "Blocked Card": "Blockerat kort",
  "Expired Card": "Kortet har gått ut",
  "Invalid Card Number": "Ogiltigt kortnummer",
  "CVC Declined": "Ogiltigt CVC-nummer",
};

const AdyenView = ({ view, model }) => {
  const paymentContainer = useRef();
  const [errorMsg, setErrorMsg] = useState(false);
  const challengeShopperContainer = useRef();

  useEffect(() => {
    if (!paymentContainer.current) return;
    let card;
    let cardState = {};

    const validate = ({ errors = [], silent } = {}) => {
      if (cardState.isValid) return { errors, silent };

      const cardErrors = Object.values(cardState.errors || {});
      return {
        errors: [
          ...errors,
          ...(cardErrors.length ? cardErrors : ["No card data"]),
        ],
        silent,
      };
    };

    const createCheckout = async () => {
      const configuration = {
        countryCode: "SE",
        locale: app.settings.adyen.locale,
        environment: app.settings.adyen.environment,
        clientKey: app.settings.adyen.clientKey,
      };

      let handleMessage;
      challengeShopperContainer.current.style.display = "none";
      challengeShopperContainer.current.style.height = "400px";
      paymentContainer.current.style.display = "";

      const on3DSresponse = ({ refusalReason }) => {
        challengeShopperContainer.current.style.display = "none";
        paymentContainer.current.style.display = "none";
        if (!refusalReason) return;

        setErrorMsg(errorRespons[refusalReason] || refusalReason);
      };
      app.connection.on("3DSresponse", on3DSresponse);

      const checkout = await AdyenCheckout(configuration);

      card = new Card(checkout, {
        showPayButton: false,

        hasHolderName: true,
        holderNameRequired: true,
        name: "Credit or debit card",
        amount: { value: 0, currency: "SEK" },
        storePaymentMethod: true,

        onSubmit: async (state, component) => {
          if (!state.isValid) {
            setErrorMsg(null);
            return;
          }

          const data = state.data;
          const partId = app.uuid();

          for (const key of Object.keys(data.paymentMethod)) {
            await app.connection.emit({
              type: "adyenSaveCard",
              partId,
              key,
              data: data.paymentMethod[key],
            });
          }

          await app.connection.emit({
            type: "adyenSaveCard",
            partId,
            key: "riskData",
            data: data.riskData,
          });

          const result = await app.connection.emit({
            type: "adyenSaveCard",
            partId,
            data: {
              ...data,
              paymentMethod: undefined,
              riskData: undefined,
            },
            pathname: window.location.pathname,
          });

          /* if (result.action?.subtype === "challenge") {
            app.event("hideActionButton");
            paymentContainer.current.style.display = "none";
            const data = uudecode(result.action.token);
            const cReqData = {
              threeDSServerTransID: data.threeDSServerTransID,
              acsTransID: data.acsTransID,
              messageVersion: data.messageVersion,
              challengeWindowSize: "05",
              messageType: "CReq",
            };
            const form = document.createElement("form");

            form.method = "POST";
            form.action = data.acsURL;
            form.target = "challengeShopperContainer";

            const element = document.createElement("input");
            element.type = "hidden";
            element.value = uuencode(cReqData);
            element.name = "creq";

            form.appendChild(element);
            challengeShopperContainer.current.style.display = "";
            document.body.appendChild(form);
            form.submit();

            return;
          }*/

          if (result.action) {
            if (result.action.type === "redirect") {
              const form = document.createElement("form");
              form.method = "POST";
              form.action = result.action.url;
              Object.entries(result.action.data).forEach(([key, value]) => {
                const element = document.createElement("input");
                element.type = "hidden";
                element.value = value;
                element.name = key;
                form.appendChild(element);
              });
              document.body.appendChild(form);
              form.submit();
              return;
            }

            app.event("hideActionButton");
            const freshCheckout = await AdyenCheckout(configuration);
            freshCheckout
              .createFromAction(result.action, { challengeWindowSize: "05" })
              .mount(paymentContainer.current);
            return;
          }

          if (result.refusalReason)
            setErrorMsg(
              errorRespons[result.refusalReason] || result.refusalReason,
            );
        },

        onChange: (state) => {
          cardState = state;
        },
      });

      card.mount(paymentContainer.current);
    };

    createCheckout();

    const submit = async () => {
      await card.submit();
    };

    view.on("submit", 100, submit);
    view.on("validate", validate);
    if (view.baseView) view.baseView.on("submit", 100, submit);
    if (view.baseView) view.baseView.on("validate", validate);

    // -------------------------
    // Cleanup
    // -------------------------
    return () => {
      card?.unmount();
      view.off("submit", submit);
      view.off("validate", validate);
      if (view.baseView) view.baseView.off("submit", submit);
      if (view.baseView) view.baseView.off("validate", validate);
    };
  }, [view]);

  return (
    <Wrapper className={model.className} renderAs={model.renderAs}>
      <div className="payment-container">
        <div ref={paymentContainer} className="payment"></div>
        <iframe
          ref={challengeShopperContainer}
          title="challengeShopperContainer"
          name="challengeShopperContainer"
          className="challengeShopperContainer w-full"
        />
        {errorMsg && (
          <Wrapper className="text-red-500">
            <Wrapper className="font-bold pt-2 pl-1">
              {app.t("Sparade av kort misslyckades")}
            </Wrapper>
            <Wrapper className="font-bold p-1">{app.t(errorMsg)}</Wrapper>
          </Wrapper>
        )}
      </div>
    </Wrapper>
  );
};

export default AdyenView;
